interface SafariNavigator extends Navigator {
  standalone?: boolean;
}

export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;

  const matchesStandalone = window.matchMedia?.('(display-mode: standalone)').matches ?? false;
  const iosStandalone = (window.navigator as SafariNavigator).standalone === true;

  return matchesStandalone || iosStandalone;
}
